import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./auth.css";
import companyLogo from "../../Assets/forbeslogo.png";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const SignIn = ({ setUser }) => {
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const handleSignIn = async () => {
    if (token.length < 4 || token.length > 5 || !password) {
      setMessage("Please enter valid credentials.");
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/api/auth/signin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token_no: token.toUpperCase(), password }),
      });

      const data = await response.json();
      // console.log("data = ", data);

      if (!response.ok) {
        setMessage(data.message || "Login failed.");
      } else if (data.is_blocked) {
        // ✅ handle blocked users
        setMessage("Your account is blocked. Contact admin.");
      } else {
        localStorage.setItem("user", JSON.stringify(data));
        setUser(data);

        // console.log("user role = ", data.role);

        // ✅ normalize role check (case-insensitive)
        switch (data.role?.toLowerCase()) {
          case "requester":
          case "admin": // admin also goes to requester
            navigate("/requester");
            break;
          case "driver":
            navigate("/driver");
            break;
          case "maintenancehead":
            navigate("/maintenance-head");
            break;
          default:
            setMessage("Unknown role. Contact admin.");
        }
      }
    } catch (error) {
      console.error("Signin error:", error);
      setMessage("Server error. Please try again later.");
    }
  };

  return (
    <div className="auth-container">
      <div className="background-overlay" />
      <img src={companyLogo} alt="Company Logo" className="logo-container" />
      <div className="auth-content">
        <div className="welcome-text">
          <h1>Welcome to FMTMS!</h1>
        </div>

        <div className="auth-box">
          <div className="input-container">
            <input
              type="text"
              placeholder="Enter Token Number"
              maxLength="5"
              value={token}
              onChange={(e) => setToken(e.target.value.trim())}
            />
          </div>
          <div className="input-container" style={{ position: "relative" }}>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ paddingRight: "2.5rem" }}
            />
            <span
              onClick={() => setShowPassword((prev) => !prev)}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                fontSize: "1rem",
                color: "#333",
                userSelect: "none",
              }}
              title={showPassword ? "Hide Password" : "Show Password"}
            >
              {showPassword ? "👁︎" : "👁️"}
            </span>
          </div>

          <button
            onClick={handleSignIn}
            disabled={
              token.length < 4 || token.length > 5 || password.length === 0
            }
          >
            SIGN IN
          </button>
          <p className="redirect-message">
            Forgot your password?{" "}
            <Link to="/forgot-password" className="signup-link">
              Reset here
            </Link>
          </p>

          <p className="redirect-message">
            Don't have an account?{" "}
            <Link to="/signup" className="signup-link">
              Sign up
            </Link>
          </p>
          {message && <p className="error-message">{message}</p>}
        </div>
      </div>
    </div>
  );
};

export default SignIn;
